(() => {
  const body = document.querySelector('.shopify-policy__body');
  if (!body || body.dataset.motPolicyReady) return;
  body.dataset.motPolicyReady = 'true';
  const before = body.textContent.replace(/\s+/g, ' ').trim();
  const working = body.cloneNode(true);
  working.querySelectorAll('p').forEach(paragraph => {
    const output = document.createDocumentFragment();
    let current = document.createElement('p');
    let breaks = 0;
    const flush = () => {
      if (current.textContent.trim()) {
        const sole = current.children.length === 1 ? current.firstElementChild : null;
        if (sole && sole.tagName === 'STRONG' && sole.textContent.trim() === current.textContent.trim()) {
          const heading = document.createElement('h3');
          heading.textContent = sole.textContent.trim();
          output.append(heading);
        } else {
          output.append(current);
        }
      }
      current = document.createElement('p');
    };
    Array.from(paragraph.childNodes).forEach(node => {
      if (node.nodeName === 'BR') { breaks++; return; }
      if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
        if (!breaks && current.childNodes.length) current.append(node.cloneNode(true));
        return;
      }
      if (node.nodeName === 'STRONG' && /^(OVERVIEW|SECTION\s+\d+\s*[-–])/i.test(node.textContent.trim())) {
        flush();
        const heading = document.createElement('h2');
        heading.textContent = node.textContent.trim();
        output.append(heading);
        breaks = 0;
        return;
      }
      if (breaks >= 2) flush();
      else if (breaks === 1 && current.childNodes.length) current.append(document.createElement('br'));
      breaks = 0;
      current.append(node.cloneNode(true));
    });
    flush();
    paragraph.replaceWith(output);
  });
  const after = working.textContent.replace(/\s+/g, ' ').trim();
  if (before.replace(/\s/g, '') !== after.replace(/\s/g, '')) return;
  body.replaceChildren(...Array.from(working.childNodes));
  const headings = Array.from(body.querySelectorAll('h2'));
  if (headings.length > 1) {
    const index = document.createElement('details');
    index.className = 'mot-policy-index';
    const summary = document.createElement('summary');
    summary.textContent = 'On this page';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Policy sections');
    const list = document.createElement('ol');
    headings.forEach((heading, position) => {
      if (!heading.id) heading.id = 'mot-policy-section-' + (position + 1);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });
    nav.append(list);
    index.append(summary, nav);
    body.prepend(index);
  }
})();